'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteThumbnail = exports.createCategory = exports.editRecordingTitle = exports.createThumbnail = exports.CONTENTS_ERROR_HANDLED = exports.RESET_CONTENTS_STATE = exports.DELETE_THUMBNAIL_FAILURE = exports.DELETE_THUMBNAIL_COMPLETE = exports.DELETE_THUMBNAIL_START = exports.CREATE_CATEGORY_FAILURE = exports.CREATE_CATEGORY_COMPLETE = exports.CREATE_CATEGORY_START = exports.CREATE_THUMBNAIL_FAILURE = exports.CREATE_THUMBNAIL_COMPLETE = exports.CREATE_THUMBNAIL_START = exports.UPDATE_RECORDING_TITLE_FAILURE = exports.UPDATE_RECORDING_TITLE_COMPLETE = exports.UPDATE_RECORDING_TITLE_START = exports.GET_GROUP_CONTENT_FAILURE = exports.GET_GROUP_CONTENT_COMPLETE = exports.GET_GROUP_CONTENT_START = undefined;
exports.getGroupContents = getGroupContents;
exports.contentErrorHandled = contentErrorHandled;
exports.resetContentsState = resetContentsState;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Types

var GET_GROUP_CONTENT_START = exports.GET_GROUP_CONTENT_START = 'GET_GROUP_CONTENT_START';
var GET_GROUP_CONTENT_COMPLETE = exports.GET_GROUP_CONTENT_COMPLETE = 'GET_GROUP_CONTENT_COMPLETE';
var GET_GROUP_CONTENT_FAILURE = exports.GET_GROUP_CONTENT_FAILURE = 'GET_GROUP_CONTENT_FAILURE';

var UPDATE_RECORDING_TITLE_START = exports.UPDATE_RECORDING_TITLE_START = 'UPDATE_RECORDING_TITLE_START';
var UPDATE_RECORDING_TITLE_COMPLETE = exports.UPDATE_RECORDING_TITLE_COMPLETE = 'UPDATE_RECORDING_TITLE_COMPLETE';
var UPDATE_RECORDING_TITLE_FAILURE = exports.UPDATE_RECORDING_TITLE_FAILURE = 'UPDATE_RECORDING_TITLE_FAILURE';

var CREATE_THUMBNAIL_START = exports.CREATE_THUMBNAIL_START = 'CREATE_THUMBNAIL_START';
var CREATE_THUMBNAIL_COMPLETE = exports.CREATE_THUMBNAIL_COMPLETE = 'CREATE_THUMBNAIL_COMPLETE';
var CREATE_THUMBNAIL_FAILURE = exports.CREATE_THUMBNAIL_FAILURE = 'CREATE_THUMBNAIL_FAILURE';

var CREATE_CATEGORY_START = exports.CREATE_CATEGORY_START = 'CREATE_CATEGORY_START';
var CREATE_CATEGORY_COMPLETE = exports.CREATE_CATEGORY_COMPLETE = 'CREATE_CATEGORY_COMPLETE';
var CREATE_CATEGORY_FAILURE = exports.CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';

var DELETE_THUMBNAIL_START = exports.DELETE_THUMBNAIL_START = 'DELETE_THUMBNAIL_START';
var DELETE_THUMBNAIL_COMPLETE = exports.DELETE_THUMBNAIL_COMPLETE = 'DELETE_THUMBNAIL_COMPLETE';
var DELETE_THUMBNAIL_FAILURE = exports.DELETE_THUMBNAIL_FAILURE = 'DELETE_THUMBNAIL_FAILURE';

// RESET
var RESET_CONTENTS_STATE = exports.RESET_CONTENTS_STATE = 'RESET_CONTENTS_STATE';

// error handling for thumbnails and event category
var CONTENTS_ERROR_HANDLED = exports.CONTENTS_ERROR_HANDLED = 'CONTENTS_ERROR_HANDLED';

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------

var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-contents');
    }
    logger.error(msg, attributes);
}

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Bearer ' + state.auth.authInfo.access_token;
    }

    return header;
}

// ------------------------------------------------------------------ READ CALLS ------------------------------------------------------------------

// TODO: It should get option which implies index
function getGroupContents(contentKeys, pageNo, needsAuth, numberOfGroups) {
    var reqUrl = contentKeys.length !== 0 ? baseUrl() + '/contents?ids=' + contentKeys : baseUrl() + '/contents';

    return function (dispatch, getState) {
        var state = getState();
        var header = needsAuth ? getheader(state) : getheader();

        if (state.contents.data.length > 0) {
            return new Promise(function (resolve) {
                resolve(state.contents.data);
            });
        }

        dispatch({ type: GET_GROUP_CONTENT_START });
        return HTTP.getData(reqUrl, header).then(function (response) {
            dispatch({ type: GET_GROUP_CONTENT_COMPLETE, contents: response, pageNumber: pageNo, numberOfGroups: numberOfGroups });
            return Promise.resolve(response);
        }).catch(function (error) {
            loggingHelper('failed to get all contents', { method: 'getGroupContents', callType: 'GET', pageNo: pageNo, needsAuth: needsAuth, error: error });
            dispatch({ type: GET_GROUP_CONTENT_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}

// ------------------------------------------------------------------ CREATE CALLS ------------------------------------------------------------------

var createThumbnail = exports.createThumbnail = function createThumbnail(contentId, thumbnailInfo) {
    return function (dispatch, getStore) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/thumbnails';
        var store = getStore();
        var header = getheader(store);

        dispatch({ type: CREATE_THUMBNAIL_START });

        return HTTP.postData(contentServiceUrl, header, thumbnailInfo).then(function (content) {
            dispatch({ type: CREATE_THUMBNAIL_COMPLETE, content: content, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to create a new thumbnail', { method: 'createThumbnail', callType: 'POST', contentId: contentId, thumbnailInfo: thumbnailInfo, error: error });
            dispatch({ type: CREATE_THUMBNAIL_FAILURE, error: error, dataCall: 'postContentThumbnail' });
        });
    };
};

// ------------------------------------------------------------------ UPDATE CALLS ------------------------------------------------------------------

var editRecordingTitle = exports.editRecordingTitle = function editRecordingTitle(contentId, fileTitleInfo) {
    return function (dispatch, getStore) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId;
        var store = getStore();
        var header = getheader(store);

        dispatch({ type: UPDATE_RECORDING_TITLE_START });

        return HTTP.putData(contentServiceUrl, header, fileTitleInfo).then(function (content) {
            dispatch({ type: UPDATE_RECORDING_TITLE_COMPLETE, content: content, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to edit a recording title', { method: 'editRecordingTitle', callType: 'PUT', contentId: contentId, fileTitleInfo: fileTitleInfo, error: error });
            dispatch({ type: UPDATE_RECORDING_TITLE_FAILURE, error: error, dataCall: 'putRecordingTitle' });
        });
    };
};

var createCategory = exports.createCategory = function createCategory(contentId, category) {
    return function (dispatch, getStore) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId;
        var store = getStore();
        var header = getheader(store);

        if (category.category === 'GENERAL') {
            category.category = null;
        }

        dispatch({ type: CREATE_CATEGORY_START });
        return HTTP.putData(contentServiceUrl, header, category).then(function (content) {
            dispatch({ type: CREATE_CATEGORY_COMPLETE, content: content });
        }).catch(function (error) {
            loggingHelper('failed to update the category for a recording', { method: 'createCategory', callType: 'PUT', contentId: contentId, category: category, error: error });
            dispatch({ type: CREATE_CATEGORY_FAILURE, error: error, dataCall: 'putContentCategory' });
        });
    };
};

// ------------------------------------------------------------------ DELETE CALLS ------------------------------------------------------------------

var deleteThumbnail = exports.deleteThumbnail = function deleteThumbnail(contentId) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/thumbnails';
        var store = getState();
        var header = getheader(store);

        dispatch({ type: DELETE_THUMBNAIL_START });

        return HTTP.deleteData(contentServiceUrl, header).then(function () {
            dispatch({ type: DELETE_THUMBNAIL_COMPLETE, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to delete a recording thumbnail', { method: 'deleteThumbnail', callType: 'DELETE', contentId: contentId, error: error });
            dispatch({ type: DELETE_THUMBNAIL_FAILURE, error: error, dataCall: 'deleteContentThumbnail' });
        });
    };
};

function contentErrorHandled() {
    return function (dispatch) {
        dispatch({ type: CONTENTS_ERROR_HANDLED });
    };
}

function resetContentsState() {
    return function (dispatch, getStore) {
        dispatch({ type: RESET_CONTENTS_STATE });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/contents.js
// module id = 759
// module chunks = 0